import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { logout, getUser, sendTestReport } from '../api';
import { PLATFORMS, CHORD } from '../constants';

export default function Navbar() {
  const navigate  = useNavigate();
  const location  = useLocation();
  const user      = getUser();
  const [sending, setSending] = useState(false);
  const [msg, setMsg]         = useState('');

  function handleLogout() { logout(); navigate('/login'); }

  async function handleTestEmail() {
    setSending(true); setMsg('');
    try {
      const res = await sendTestReport(7);
      setMsg('✓ Sent to harsh.vyas@1702digital.com');
    } catch(e) { setMsg('✗ ' + e.message); }
    finally {
      setSending(false);
      setTimeout(() => setMsg(''), 5000);
    }
  }

  const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + '/');

  return (
    <nav style={{
      background: CHORD.softBlack,
      borderBottom: `1px solid ${CHORD.border}`,
      padding: '0 1.5rem',
      height: 54,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      position: 'sticky',
      top: 0,
      zIndex: 200,
    }}>
      <div style={{ display:'flex', alignItems:'center', gap:2, overflowX:'auto' }}>
        {/* Logo */}
        <div onClick={() => navigate('/')} style={{ marginRight:16, cursor:'pointer', flexShrink:0 }}>
          <span style={{ fontSize:17, fontWeight:700, letterSpacing:'-0.5px', color: CHORD.beige }}>chord</span>
          <span style={{ fontSize:17, fontWeight:700, color: CHORD.coral }}>.</span>
        </div>

        <NavBtn label="Dashboard" active={location.pathname === '/'} onClick={() => navigate('/')} color={CHORD.lime} />

        {PLATFORMS.map(p => (
          <NavBtn key={p.key} label={p.short}
            active={isActive(`/platform/${p.key}`)}
            onClick={() => navigate(`/platform/${p.key}`)}
            color={p.color}
          />
        ))}

        {user?.role === 'admin' && (
          <NavBtn label="Activity" active={isActive('/activity')} onClick={() => navigate('/activity')} color={CHORD.orange} />
        )}
        <NavBtn label="Campaigns" active={isActive('/campaigns')} onClick={() => navigate('/campaigns')} color={CHORD.coral} />
      </div>

      <div style={{ display:'flex', alignItems:'center', gap:10, flexShrink:0, marginLeft:12 }}>
        {msg && <span style={{ fontSize:11, color: msg.startsWith('✓') ? '#1D9E75' : '#E55D4A', whiteSpace:'nowrap' }}>{msg}</span>}
        {user?.role === 'admin' && (
          <button onClick={handleTestEmail} disabled={sending} title="Send yourself a test of the Monday activity report"
            style={{
              background: 'rgba(216,224,77,0.1)', border: `0.5px solid rgba(216,224,77,0.3)`,
              borderRadius: 6, color: '#D8E04D', fontSize: 11,
              padding: '4px 10px', cursor: sending ? 'wait' : 'pointer', fontFamily: 'inherit',
              opacity: sending ? 0.6 : 1, whiteSpace: 'nowrap',
            }}>{sending ? '⏳ Sending...' : '✉ Test Email'}</button>
        )}
        <span style={{ fontSize:12, color: CHORD.textMuted }}>{user?.email}</span>
        <span style={{
          fontSize: 10, padding: '2px 8px',
          background: `${CHORD.coral}22`, color: CHORD.coral,
          borderRadius: 20, textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight:600,
        }}>{user?.role}</span>
        <button onClick={handleLogout} style={{
          background: 'none', border: `0.5px solid ${CHORD.border}`,
          borderRadius: 6, color: CHORD.textMuted, fontSize: 12,
          padding: '4px 10px', cursor: 'pointer', fontFamily: 'inherit',
        }}>Out</button>
      </div>
    </nav>
  );
}

function NavBtn({ label, active, onClick, color }) {
  return (
    <button onClick={onClick} style={{
      background: active ? `${color}18` : 'none',
      border: 'none',
      borderBottom: `2px solid ${active ? color : 'transparent'}`,
      cursor: 'pointer', fontFamily: 'inherit',
      fontSize: 12, padding: '6px 12px', whiteSpace: 'nowrap',
      color: active ? color : 'rgba(245,235,221,0.4)',
      fontWeight: active ? 700 : 400,
      letterSpacing: '0.3px',
      transition: 'all 0.15s',
    }}>{label}</button>
  );
}
